export default {
  small: '(max-width: 700px)',
  medium: '(max-width: 1024px)',
};
